
/**
 * 소셜 관계 정보
 */
export type ChatMessageListResponsePageAllOfThreeContentItemAllOfSenderSocial = {
  /** 대상 사용자가 현재 사용자를 팔로우하는지 여부 */
  isFollower: boolean;
  /** 현재 사용자가 대상 사용자를 팔로우하는지 여부 */
  isFollowing: boolean;
};
